// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"9472d136","158":"c362f8ee","213":"b278e2ff","320":"3282fb00","455":"70cb0b06","544":"ad30227a","573":"bb486095","725":"c92e51d4","764":"3cc99d25","857":"748cbdce","905":"4397bfc1","942":"d2c817e8"}[chunkId] + ".chunk.js";
};